// extracted by mini-css-extract-plugin
export default {"container":"R9mnQSo","body":"z8CtOyj fVdHxMU","leftBody":"w45mOEA"};